export enum ProductTipType {
    'AGE',
    'WATER_AMOUNT',
    'CONSUMPTION',
    'ORIGIN',
    'LOCATION',
    'NUTRITION',
    'TEMPERATURE',
    'CUTTING',
}
